import axios from "axios";

import { PaymentSessionToken } from "redmond";
import { purchaseApi, QuoteResponseV0 } from "@b2bportal/purchase-api";
import { ProductFunnelHeaderName, ProductFunnelHeader } from "./productFunnel";

const pollPriceQuote = (
  req: PaymentSessionToken,
  productFunnel: ProductFunnelHeader = ProductFunnelHeader.Hotels
): Promise<QuoteResponseV0> =>
  new Promise((resolve, reject) => {
    try {
      const res = purchaseApi(axios).apiV0PurchaseQuotePollPost(
        {
          value: req.value,
        },
        { headers: { [ProductFunnelHeaderName]: productFunnel } }
      );

      res.then((body) => resolve(body.data)).catch((e) => reject(e));
    } catch (e) {
      reject(e);
    }
  });

export default pollPriceQuote;
